import { AdvertisementTypeEnum } from "@app/types/enums";
import uobLogo from "@assets/logo-uob-blue.png";
import aseanBusinessLogo from "@assets/verticals/asean-logo-black.svg";
import Advertisement from "@components/Advertisement/Advertisement";
import PrestitialAd from "@components/Advertisement/PrestitialAd";
import Banner from "@components/Banner/Banner";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";
import { sectionNavigationItems } from "@util/constant";
import { GoogleAdsSlotFactory } from "@util/helpers";

export default function AseanBanner(): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const slot = sectionNavigationItems["international/asean"]
    ? GoogleAdsSlotFactory.lb1(
        sectionNavigationItems["international/asean"].link
          .split("/")
          .filter((a) => a !== "")
          .join("/")
      )
    : null;

  return (
    <>
      {sectionNavigationItems["international/asean"] ? (
        <SectionMasthead
          link={sectionNavigationItems["international/asean"].link}
          masthead={{
            alt: "Asean Business logo",
            src: aseanBusinessLogo,
            width: 240,
            height: 57,
          }}
        />
      ) : null}

      <Banner rootClassName="w-full bg-gray-250 py-3">
        <div className="flex items-center justify-end gap-x-4">
          <span className="font-poppins text-base font-light">
            SPONSORED BY
          </span>
          <img src={uobLogo} alt="UOB logo" width="140" />
        </div>
      </Banner>

      {slot ? (
        <>
          <Advertisement
            rootClassName="pb-6"
            adUnitProps={{ type: AdvertisementTypeEnum.LB1, slot: slot }}
          />

          {OKTAUserInfo?.usertype !== OKTAUserTypeEnum.SUBSCRIBER ? (
            <PrestitialAd slot={slot} />
          ) : null}
        </>
      ) : null}
    </>
  );
}
